import {Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent{
    @Input()
    pageNumbers: number;

    @Input()
    currentPageNumber: number;

    @Input()
    endOfSet: boolean;

    @Output()
    selectedPage = new EventEmitter<number>();

    onClickPageNumber(pageNumber: number){
        this.currentPageNumber = pageNumber;
        this.selectedPage.emit(pageNumber);
    }
    
    onClickPrevious(){
        this.currentPageNumber = this.currentPageNumber - 1;
        this.selectedPage.emit(this.currentPageNumber);
    }

    onClickNext(){
        this.currentPageNumber = this.currentPageNumber + 1;
        this.selectedPage.emit(this.currentPageNumber);
    }

    createRange(number: number){
        return new Array(number).fill(0)
        .map((n, index) => index + 1);
    }
}

